module.exports = __webpack_public_path__ + "img/23-green.26b8f570.svg";